export default __webpack_public_path__ + "static/media/0x6ccf12b480a99c54b23647c995f4525d544a7e72.246fa8dd.webp";